import { graphql, useStaticQuery } from "gatsby";

export function useSiteMetadata() {
  const data = useStaticQuery(graphql`
    query SiteMetadataQuery {
      site {
        siteMetadata {
          siteUrl
          appUrl
          siteName
          titleTemplate
          description
          twitterUsername
          defaultImage
        }
      }
    }
  `);

  return data.site.siteMetadata;
}
